import React from 'react';
import ReactDOM from 'react-dom';
import Cookieconsent from './Cookieconsent';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<Cookieconsent />, document.getElementById('cookieconsent'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
